<template>
  <div class="home-view">
    <router-view/>
    <banner-home/>
    <layput-events/>
  </div>

</template>

<script>
import bannerHome from '../../../components/background/background'
import layputEvents from '../../../components/mt-home/mt-layout-events'
export default {
  name: 'HomeView',
  components: {
    bannerHome, layputEvents
  },
  mounted () {
    if (this.$route.name !== 'Zonas') {
      window.localStorage.clear()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/home/home.view.vue